import * as t from 'io-ts'

import fetchApi from '../fetch-api'


type HtmlRequest = { url:string };

export const getWebPageHtmlByUrl = (props:HtmlRequest) => {
  return fetchApi({
			service: "admin-service",
			method: 'POST',
			pathname: `/get-web-page-by-url`,
			headers: { "Content-Type": "application/json" },
			codec: t.type({ html: t.string }),
			body: props
	})
}